export const toCamel = (str: string): string => {
  return str
    .replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ""))
    .replace(/^(.)/, (m) => m.toLowerCase());
};

export const keysToCamel = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map((v) => keysToCamel(v));
  }

  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        toCamel(key),
        keysToCamel(value),
      ]),
    );
  }

  return data;
};

export const toSnake = (str: string): string => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

export const keysToSnake = (data: any): any => {
  if (Array.isArray(data)) {
    return data.map((v) => keysToSnake(v));
  }

  if (data !== null && typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        toSnake(key),
        keysToSnake(value),
      ]),
    );
  }

  return data;
};

export const normalizeApiResponse = (response: any) => {
  return keysToCamel(response);
};

export const removeBase64Prefix = (data?: string) =>
  typeof data === "string"
    ? data.replace(/^data:image\/\w+;base64,/, "")
    : data;

export const getRemainingTime = (
  expiredTime: string | Date | null | undefined,
  depositedAt: string | Date | null | undefined,
): string => {
  if (!expiredTime || !depositedAt) return "";

  const now = new Date(depositedAt);
  const expired = new Date(expiredTime);

  if (isNaN(now.getTime()) || isNaN(expired.getTime())) return "";

  let diff = expired.getTime() - now.getTime();

  if (diff <= 0) return "00:00:00";

  const hours = Math.floor(diff / (1000 * 60 * 60));
  diff -= hours * 1000 * 60 * 60;

  const minutes = Math.floor(diff / (1000 * 60));
  diff -= minutes * 1000 * 60;

  const seconds = Math.floor(diff / 1000);

  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const startCountdown = (
  expiredTime: string | Date,
  depositedAt: string | Date,
  callback: (timeStr: string) => void,
): number => {
  callback(getRemainingTime(expiredTime, depositedAt));
  const intervalId = window.setInterval(() => {
    callback(getRemainingTime(expiredTime, depositedAt));
  }, 1000);

  return intervalId;
};
